module.exports = __webpack_public_path__ + "static/media/flow.a91d937d.PNG";